import {useState} from "react";
import PhoneListModal from "../../modals/phoneList-modal/PhoneListModal";
import {FaPhoneAlt} from "react-icons/fa";
import "./style.less"

export default function PhoneButton() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const toggleModal = () => setIsModalOpen((currentValue) => !currentValue)

  return <>
    <button className="header-contact-button" type="button" onClick={toggleModal} aria-label="Відкрити контакти лікарні">
      <span className="header-contact-button__icon"><FaPhoneAlt/></span>
      <span className="header-contact-button__text">
        <span className="header-contact-button__label">Потрібна допомога?</span>
        <span className="header-contact-button__title">Контакти</span>
      </span>
    </button>
    {isModalOpen && <PhoneListModal isOpen={isModalOpen} onClose={toggleModal}/>}
  </>
}
